import { postQualificationTokenPayloadSchema } from '@epilot/journey-logic-commons/src/schemas/v4'
import type { PostQualificationTokenPayload } from '@epilot/journey-logic-commons/src/types/next'
import { jwtDecode } from 'jwt-decode'
import { omit } from 'radashi'

import { setAppError } from '../../store/actions/setAppError'
import { APP_ERROR } from '../../store/types/enums'

import { ParamsSchema } from './schema'
import type { AppParams } from './types'

export const parseAppParams = (queryString: string): AppParams => {
  const search = new URLSearchParams(queryString)
  const parsed = ParamsSchema.parse(Object.fromEntries(search.entries()))
  const contextData: AppParams['contextData'] = {}

  if (parsed.journeyToken) {
    const token = parseJourneyToken(parsed.journeyToken) ?? {}

    parsed.journeyId = token?.journey_id as string | undefined // overrides
    Object.assign(contextData, omit(token, ['journey_id'])) // adds the rest as contextual data
  }

  if (!parsed.isEmbedded) {
    // override based on the iframe detection
    parsed.isEmbedded = isThisAnIframe()
  }

  return { ...parsed, contextData }
}

/**
 * TODO: convert to store action and store token details
 */
export const parseJourneyToken = (token: string) => {
  try {
    const decoded = jwtDecode<PostQualificationTokenPayload>(token)
    const parsed = postQualificationTokenPayloadSchema.parse(decoded)

    // __naively__ checks if the token has expired
    if (typeof parsed.exp !== 'undefined' && parsed.exp * 1000 < Date.now()) {
      return void setAppError({
        error: APP_ERROR.JOURNEY_TOKEN_EXPIRED,
        reason: 'The provided token has expired.'
      })
    }

    return omit(parsed, ['aud', 'exp', 'iat', 'iss', 'jti', 'nbf', 'sub'])
  } catch (originalError) {
    const error = new Error('Failed to parse Journey token')

    error.cause = originalError

    // eslint-disable-next-line no-console
    console.error(error)
  }
}

export const isThisAnIframe = () => window.self !== window.top
